// extracted by mini-css-extract-plugin
export default {"backdrop":"Loading-Spinner_backdrop__3yZcP","modal":"Loading-Spinner_modal__qMI4T"};